import { useLocation } from "react-router-dom";

/**
 * 嵌入模式判定 SSOT。
 *
 * ERP 用 `{base}/analysis-runs/{uc}/{run}?embed=1&ticket=...` 在 iframe 里打开只读结果页
 * (见 docs/API.md §4.3)。此前 AppShell / 结果页 各写了一份等价判断, 加第三处消费方时
 * 必然漂移 —— 收敛到这里。
 */
export function isEmbeddedMode(search: string): boolean {
  const params = new URLSearchParams(search);
  return (
    params.get("embed") === "1" ||
    params.get("embed") === "true" ||
    params.get("frame") === "erp"
  );
}

/** 组件内读当前路由的嵌入态。 */
export function useEmbedded(): boolean {
  return isEmbeddedMode(useLocation().search);
}
